import React, { useState, useEffect } from 'react';
import styles from './Captcha.module.css';

const generateCaptchaText = (length = 6) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

const Captcha = ({ setCaptchaValue }) => {
    const [captchaText, setCaptchaText] = useState('');

    const refreshCaptcha = () => {
        const newCaptchaText = generateCaptchaText();
        setCaptchaText(newCaptchaText);
        setCaptchaValue(newCaptchaText); // Pass the value to the parent component
    };

    useEffect(() => {
        refreshCaptcha();
    }, []);

    const renderCaptchaImage = () => {
        return (
            <svg width="150" height="50" className={styles.captchaSvg}>
                <rect width="100%" height="100%" fill="#f7f7f7" />
                {captchaText.split('').map((char, index) => {
                    const angle = Math.random() * 40 - 20; // -20 to +20 degrees
                    const xPos = 15 + index * 20;
                    const yPos = 30 + (Math.random() * 10 - 5); // Random vertical offset
                    return (
                        <text
                            key={index}
                            x={xPos}
                            y={yPos}
                            fontFamily="Arial, sans-serif"
                            fontSize="28"
                            fill="#444"
                            transform={`rotate(${angle}, ${xPos}, ${yPos})`}
                        >
                            {char}
                        </text>
                    );
                })}
            </svg>
        );
    };

    return (
        <div className={styles.captchaContainer}>
            <div className={styles.captchaImage} aria-label="CAPTCHA image">
                {renderCaptchaImage()}
            </div>
            <button type="button" onClick={refreshCaptcha} className={styles.refreshButton}>
                &#x21bb; {/* Unicode for refresh icon */}
            </button>
        </div>
    );
};

export default Captcha;